// extracted by mini-css-extract-plugin
export default {"header":"ProductsList_header__5LiO4","supplierHeader":"ProductsList_supplierHeader__k0n4C"};